import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import RequireRole from './auth/RequireRole';
import LandingPage from './pages/LandingPage';
import DashboardLayout from './dashboards/icib-admin/DashboardLayout';
import OverviewView from './dashboards/icib-admin/views/OverviewView';
import EmployeesView from './dashboards/icib-admin/views/EmployeesView';
import IntakeView from './dashboards/icib-admin/views/IntakeView';
import PendingIntakeView from './dashboards/icib-admin/views/PendingIntakeView';
import ConfirmationsView from './dashboards/icib-admin/views/ConfirmationsView';
import FollowupView from './dashboards/icib-admin/views/FollowupView';
import GroupsView from './dashboards/icib-admin/views/GroupsView';
import UsersView from './dashboards/icib-admin/views/UsersView';
import FormsView from './dashboards/icib-admin/views/FormsView';
import ProductsView from './dashboards/icib-admin/views/ProductsView';
import EmployerLayout from './dashboards/employer/EmployerLayout';
import EmployerOverviewView from './dashboards/employer/views/OverviewView';
import EmployerEmployeesView from './dashboards/employer/views/EmployeesView';
import OutstandingView from './dashboards/employer/views/OutstandingView';
import NewStarterView from './dashboards/employer/views/NewStarterView';
import LeaversView from './dashboards/employer/views/LeaversView';
import EmployerPendingIntakeView from './dashboards/employer/views/PendingIntakeView';
import EmployeeLayout from './dashboards/employee/EmployeeLayout';
import CoverView from './dashboards/employee/views/CoverView';
import SchemeView from './dashboards/employee/views/SchemeView';
import DetailsView from './dashboards/employee/views/DetailsView';
import './styles/theme.css';

// Every placeholder section cross-references its user story / endpoint in
// BrandonUserStoryAPI.md so it's easy to find what to build next. EMP-01
// through EMP-04 plus EMP-07 (overview) now have real views (see the
// explicit /employer routes below) — nothing left here for the employer
// portal. EE-01 through EE-03 now all have real views too (see the
// explicit /employee routes below) — nothing left here for the employee
// portal either; its Overview tab stays a placeholder since no `EE-`
// overview story/endpoint is documented (only ICIB-15/EMP-07 are).

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route element={<RequireRole allow={['icib_admin']} />}>
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<OverviewView />} />
              <Route path="employees" element={<EmployeesView />} />
              <Route path="intake" element={<IntakeView />} />
              <Route path="pending-intake" element={<PendingIntakeView />} />
              <Route path="confirmations" element={<ConfirmationsView />} />
              <Route path="followup" element={<FollowupView />} />
              <Route path="groups" element={<GroupsView />} />
              <Route path="users" element={<UsersView />} />
              <Route path="forms" element={<FormsView />} />
              <Route path="products" element={<ProductsView />} />
            </Route>
          </Route>

          <Route element={<RequireRole allow={['employer_admin']} />}>
            <Route path="/employer" element={<EmployerLayout />}>
              <Route index element={<EmployerOverviewView />} />
              <Route path="employees" element={<EmployerEmployeesView />} />
              <Route path="outstanding" element={<OutstandingView />} />
              <Route path="new-starter" element={<NewStarterView />} />
              <Route path="leavers" element={<LeaversView />} />
              <Route path="pending-intake" element={<EmployerPendingIntakeView />} />
            </Route>
          </Route>

          <Route element={<RequireRole allow={['employee']} />}>
            <Route path="/employee" element={<EmployeeLayout />}>
              <Route index element={<Navigate to="cover" replace />} />
              <Route path="cover" element={<CoverView />} />
              <Route path="scheme" element={<SchemeView />} />
              <Route path="details" element={<DetailsView />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
